import api from '../utils/api';
import config from '../config';
import {
  beginDriveReauth,
  clearDriveApiToken,
  getDriveApiToken,
  setDriveApiToken
} from '../lib/auth-token';
import { driveAuthApi } from '../lib/drive-auth-api';

// Types
export interface UpdateProfileData {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  bio?: string;
  location?: string;
  website?: string;
}

export interface UpdatePasswordData {
  currentPassword: string;
  newPassword: string;
}

const authService = {
  getProfile: async () => {
    const response = await api.get(`${config.api.auth}/profile`);
    return response.data.user;
  },

  updateProfile: async (profileData: UpdateProfileData) => {
    const response = await api.put(`${config.api.auth}/profile`, profileData);
    return response.data.user || response.data;
  },

  updatePassword: async (passwordData: UpdatePasswordData) => {
    const response = await api.put(`${config.api.auth}/change-password`, passwordData);
    return response.data;
  },

  logout: async () => {
    clearDriveApiToken();
    try {
      await api.post(`${config.api.auth}/logout`);
    } catch {
      /* ignore */
    }
  },

  isAuthenticated: () => {
    return Boolean(getDriveApiToken());
  },

  /** Prefer AuthBootstrap + /auth/sso/exchange; kept for rare callers. */
  exchangeSsoCredential: async (opts: { code?: string; token?: string }) => {
    const result = await driveAuthApi.exchangeSsoCredential(opts);
    const apiToken =
      result.apiToken || (result as { token?: string }).token || '';
    if (apiToken) {
      setDriveApiToken(apiToken);
    }
    return result;
  },

  /**
   * @deprecated Use beginDriveReauth / AuthBootstrap instead of /sso/login-url.
   */
  redirectToSSO: async () => {
    beginDriveReauth({ reason: 'MISSING_TOKEN' });
  }
};

export default authService;
